var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14905_9913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.61055 8.46289H14.3918",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98125 10.6191L5.76562 8.46289H12.2344L12.0187 10.6191",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11211 2.80078C7.11211 3.30117 7.31088 3.78106 7.66468 4.1349C8.01852 4.48872 8.49843 4.6875 8.99883 4.6875C9.49922 4.6875 9.97913 4.48872 10.333 4.1349C10.6867 3.78106 10.8855 3.30117 10.8855 2.80078C10.8855 2.30039 10.6867 1.8205 10.333 1.46667C9.97913 1.11284 9.49922 0.914062 8.99883 0.914062C8.49843 0.914062 8.01852 1.11284 7.66468 1.46667C7.31088 1.8205 7.11211 2.30039 7.11211 2.80078Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.334 6.30541C11.046 5.9672 10.6879 5.69557 10.2846 5.5093C9.88123 5.32303 9.44229 5.22656 8.99803 5.22656C8.55377 5.22656 8.11483 5.32303 7.71154 5.5093C7.30822 5.69557 6.95016 5.9672 6.66211 6.30541",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36406 13.584C1.36406 14.0844 1.56284 14.5643 1.91667 14.9181C2.2705 15.2719 2.75039 15.4707 3.25078 15.4707C3.75117 15.4707 4.23107 15.2719 4.58489 14.9181C4.93872 14.5643 5.1375 14.0844 5.1375 13.584C5.1375 13.0836 4.93872 12.6037 4.58489 12.2498C4.23107 11.8961 3.75117 11.6973 3.25078 11.6973C2.75039 11.6973 2.2705 11.8961 1.91667 12.2498C1.56284 12.6037 1.36406 13.0836 1.36406 13.584Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58594 17.0847C5.29789 16.7465 4.93983 16.4749 4.53651 16.2886C4.1332 16.1023 3.69425 16.0059 3.25 16.0059C2.80575 16.0059 2.3668 16.1023 1.96348 16.2886C1.56017 16.4749 1.20211 16.7465 0.914062 17.0847",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11211 13.584C7.11211 14.0844 7.31088 14.5643 7.66468 14.9181C8.01852 15.2719 8.49843 15.4707 8.99883 15.4707C9.49922 15.4707 9.97913 15.2719 10.333 14.9181C10.6867 14.5643 10.8855 14.0844 10.8855 13.584C10.8855 13.0836 10.6867 12.6037 10.333 12.2498C9.97913 11.8961 9.49922 11.6973 8.99883 11.6973C8.49843 11.6973 8.01852 11.8961 7.66468 12.2498C7.31088 12.6037 7.11211 13.0836 7.11211 13.584Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.334 17.0847C11.046 16.7465 10.6879 16.4749 10.2846 16.2886C9.88123 16.1023 9.44229 16.0059 8.99803 16.0059C8.55377 16.0059 8.11483 16.1023 7.71154 16.2886C7.30822 16.4749 6.95016 16.7465 6.66211 17.0847",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8637 13.584C12.8637 14.0844 13.0624 14.5643 13.4163 14.9181C13.7701 15.2719 14.25 15.4707 14.7504 15.4707C15.2508 15.4707 15.7306 15.2719 16.0845 14.9181C16.4383 14.5643 16.6371 14.0844 16.6371 13.584C16.6371 13.0836 16.4383 12.6037 16.0845 12.2498C15.7306 11.8961 15.2508 11.6973 14.7504 11.6973C14.25 11.6973 13.7701 11.8961 13.4163 12.2498C13.0624 12.6037 12.8637 13.0836 12.8637 13.584Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0855 17.0847C16.7975 16.7465 16.4395 16.4749 16.0361 16.2886C15.6328 16.1023 15.1939 16.0059 14.7496 16.0059C14.3053 16.0059 13.8664 16.1023 13.4631 16.2886C13.0597 16.4749 12.7017 16.7465 12.4137 17.0847",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14905_9913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamManagementIcon);
export default __webpack_public_path__ + "static/media/team-management-icon.6b07fcd242e862defc502ad8d4460436.svg";
export { ForwardRef as ReactComponent };